import type {
  OrderDetailsType,
  OrderDetailsRawDataPayload,
  refundableItemType,
} from "utils";
import { axiosEjFetch as axiosFetch } from "./axiosEjHelpers";

type OrderDetailsResponse = {
  message: string;
  orderDetails: OrderDetailsType | null;
  success: boolean;
  validationErrors: string[];
};

export async function getInvoices(reservationId: string) {
  return axiosFetch.get(
    `/api/Invoicing/getInvoicesForReservation/${reservationId}`
  );
}

export async function getOrderDetails(reservationId: string) {
  return axiosFetch.get(
    `/api/Invoicing/getOrderDetailsForReservation/${reservationId}`
  );
}

export async function getOrderDetailsWithType(
  reservationId: string,
  paymentAmountType: number
) {
  return axiosFetch.get(
    `/api/Invoicing/getOrderDetailsForReservation/${reservationId}/${paymentAmountType}`
  );
}

export async function downloadInvoice(id: string) {
  return axiosFetch.get(`/api/Invoicing/downloadInvoice/${id}`, {
    responseType: "blob",
  });
}

export async function getOrderDetailsFromRawData(
  payload: OrderDetailsRawDataPayload
): Promise<OrderDetailsResponse> {
  const response = await axiosFetch.post(
    `/api/Invoicing/getOrderDetailsFromRawData`,
    payload
  );
  return response.data;
}

export async function getRefundableItems(invoiceId: string) {
  const response = await axiosFetch.get(
    `/api/Invoice/${invoiceId}/refundableItems`
  );

  if (Array.isArray(response)) {
    return response as refundableItemType[];
  }

  return response?.data || [];
}
